export const REQUEST_GET_ALL_MERCHANTS = 'merchant/REQUEST_GET_ALL_MERCHANTS';
export const RECEIVED_GET_ALL_MERCHANTS = 'merchant/RECEIVED_GET_ALL_MERCHANTS';
export const RECEIVED_ERROR = 'merchant/RECEIVED_ERROR';
